const months: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const days: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];

export const formatDate: (date: Date, format: string) => string = (date, format) => {
    const secondFormats: string[] = ['s', 'ss'].sort((a, b) => b.length - a.length);
    const minuteFormats: string[] = ['m', 'mm'].sort((a, b) => b.length - a.length);
    const hourFormats: string[] = ['H', 'HH'].sort((a, b) => b.length - a.length);
    const dayFormats: string[] = ['dd', 'ddd', 'dddd'].sort((a, b) => b.length - a.length);
    const monthFormats: string[] = ['MM', 'MMM', 'MMMM'].sort((a, b) => b.length - a.length);
    const yearFormats: string[] = ['yyyy'].sort((a, b) => b.length - a.length);

    secondFormats.forEach(sf => {
        const regex = new RegExp(sf, 'g');

        switch (sf) {
            case 'ss':
                let seconds: string = date.getSeconds().toString();
                let length: number = seconds.length;

                if (!--length) {
                    seconds = `0${seconds}`;
                }

                format = format.replace(regex, seconds);
                break;
            case 's':
                format = format.replace(regex, date.getSeconds().toString());
                break;
            default:
                return;
        }
    });

    minuteFormats.forEach(mf => {
        const regex = new RegExp(mf, 'g');

        switch (mf) {
            case 'mm':
                let minutes: string = date.getMinutes().toString();
                let length: number = minutes.length;

                if (!--length) {
                    minutes = `0${minutes}`;
                }

                format = format.replace(regex, minutes);
                break;
            case 'm':
                format = format.replace(regex, date.getMinutes().toString());
                break;
            default:
                return;
        }
    });

    hourFormats.forEach(hf => {
        const regex = new RegExp(hf, 'g');

        switch (hf) {
            case 'HH':
                let hours: string = date.getHours().toString();
                let length: number = hours.length;

                if (!--length) {
                    hours = `0${hours}`;
                }

                format = format.replace(regex, hours);
                break;
            case 'H':
                format = format.replace(regex, date.getHours().toString());
                break;
            default:
                return;
        }
    });

    dayFormats.forEach(df => {
        const regex = new RegExp(df, 'g');

        switch (df) {
            case 'dddd':
                format = format.replace(regex, days[date.getDay()]);
                break;
            case 'ddd':
                format = format.replace(regex, days[date.getDay()].substr(0, df.length));
                break;
            case 'dd':
                let day = date.getDate();
                let dayString = day.toString();
                let length: number = dayString.length;

                if (!--length) {
                    dayString = `0${dayString}`;
                }

                format = format.replace(regex, dayString);
                break;
            default:
                return;
        }
    });

    monthFormats.forEach(mf => {
        const regex = new RegExp(mf, 'g');

        switch (mf) {
            case 'MMMM':
                format = format.replace(regex, months[date.getMonth()]);
                break;
            case 'MMM':
                format = format.replace(regex, months[date.getMonth()].substr(0, mf.length));
                break;
            case 'MM':
                let month = date.getMonth();
                let monthString = (++month).toString();
                let length: number = monthString.length;

                if (!--length) {
                    monthString = `0${monthString}`;
                }

                format = format.replace(regex, monthString);
                break;
            default:
                return;
        }
    });

    yearFormats.forEach(yf => {
        const regex = new RegExp(yf, 'g');

        switch (yf) {
            case 'yyyy':
                format = format.replace(regex, date.getFullYear().toString());
                break;
            default:
                return;
        }
    });

    return format;
};


